import React, { useState } from "react";
import { Link } from "react-router-dom";
import UserReservations from "./UserReservations";
import RentalHistory from "./RentalHistory";

export default function Dashboard() {
  const [activeTab, setActiveTab] = useState('overview');

  return (
    <div className="min-h-screen bg-customWhite p-8">
      <h2 className="text-burgundy text-3xl font-semibold mb-4">My Dashboard</h2>
      <p className="text-navy text-lg mb-8">
        Welcome to your rental dashboard. Manage your reservations and profile here.
      </p>

      {/* Tab Navigation */}
      <div className="flex space-x-4 mb-8 border-b border-gray-300">
        <button
          onClick={() => setActiveTab('overview')}
          className={`py-2 px-4 font-medium ${
            activeTab === 'overview'
              ? 'text-burgundy border-b-2 border-burgundy'
              : 'text-navy hover:text-burgundy'
          }`}
        >
          Overview
        </button>
        <button
          onClick={() => setActiveTab('reservations')}
          className={`py-2 px-4 font-medium ${
            activeTab === 'reservations'
              ? 'text-burgundy border-b-2 border-burgundy'
              : 'text-navy hover:text-burgundy'
          }`}
        >
          My Reservations
        </button>
      </div>

      {/* Tab Content */}
      {activeTab === 'overview' && (
        <div className="space-y-6">
          {/* Rental Statistics */}
          <RentalHistory />

          {/* Quick Actions */}
          <div className="bg-white rounded shadow p-6">
            <h3 className="text-burgundy text-xl font-medium mb-4">Quick Actions</h3>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <Link
                to="/reservation"
                className="bg-burgundy text-white py-3 px-4 rounded hover:bg-opacity-90 transition text-center font-medium"
              >
                Make New Reservation
              </Link>
              <Link
                to="/profile"
                className="bg-navy text-white py-3 px-4 rounded hover:bg-opacity-90 transition text-center font-medium"
              >
                Update Profile
              </Link>
            </div>
          </div>

          {/* Recent Reservations Preview */}
          <div className="bg-white rounded shadow p-6">
            <div className="flex justify-between items-center mb-4">
              <h3 className="text-burgundy text-xl font-medium">Recent Reservations</h3>
              <button
                onClick={() => setActiveTab('reservations')}
                className="text-burgundy hover:underline text-sm font-medium"
              >
                View All
              </button>
            </div>
            <UserReservations />
          </div>
        </div>
      )}

      {activeTab === 'reservations' && (
        <div>
          <div className="flex justify-between items-center mb-6">
            <h3 className="text-burgundy text-xl font-medium">My Reservations</h3>
            <Link
              to="/reservation"
              className="bg-burgundy text-white py-2 px-4 rounded hover:bg-opacity-90 transition font-medium"
            >
              New Reservation
            </Link>
          </div>
          <UserReservations />
        </div>
      )}
    </div>
  );
}
